<header class="header">
  <div class="header__inner">

    <!-- Logo -->
    <a class="header__logo" routerLink="/">
      <img src="logo.svg" alt="MilkHouse" width="163" height="48" />
    </a>

    <!-- Phones -->
    <div class="header__phones">
      @for (phone of phones(); track phone) {
        <a class="header__contact-block" [href]="phoneHref(phone)">
          <svg class="header__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.06 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
          </svg>
          <span>
            <span class="header__contact-label">Телефон</span>
            <span class="header__contact-value">{{ formatPhone(phone) }}</span>
          </span>
        </a>
      }
      @if (phones().length === 0) {
        <div class="header__contact-block header__contact-block--loading"></div>
      }
    </div>

    <a class="header__cart-btn" routerLink="/cart">
      <span class="header__cart-icon-wrap">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
        </svg>
        @if (cart.totalQuantity() > 0) {
          <span class="header__cart-badge">{{ cart.totalQuantity() }}</span>
        }
      </span>
      <span class="header__cart-label">Кошик</span>
    </a>

  </div>
</header>
